module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-13.fbfea8d7.png";